<template>
  <v-app light>
    <navbar v-if="loggedIn" />
    <v-main>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <loading />
    <toast-alert />
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';
import ToastAlert from './components/ToastAlert';
import Loading from './components/Loading';

export default {
  name: 'App',

  components: {
    Navbar,
    ToastAlert,
    Loading,
  },

  data() {
    return {};
  },

  computed: {
    loggedIn() {
      return this.$store.state.status.loggedIn;
    },
  },
};
</script>

<style lang="scss">
@import '@/sass/variables.scss';
.v-application {
  background-color: var(--v-background-base) !important;
  color: var(--v-text-base) !important;
}
.v-card {
  background-color: var(--v-background-lighten1) !important;
  color: var(--v-text-base) !important;
}
.v-menu__content .v-list {
  background-color: var(--v-background-lighten1) !important;
}
.v-data-table {
  background-color: var(--v-background-lighten1) !important;
  color: var(--v-text-base) !important;
}
.v-data-table .v-icon:not(.theme--light) {
  color: var(--v-text-base) !important;
}
.v-data-table header:not(.theme--light) {
  background-color: var(--v-background-lighten1) !important;
}
.v-input input,
.v-input:not(.v-input--is-disabled) input,
.v-input:not(.v-input--is-disabled) textarea,
.v-select__selection,
.v-file-input__text:not(.v-file-input__text--placeholder) {
  color: var(--v-text-base) !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
